(function () {
  var LOGOS = window.CEDAR_LOGOS || {};
  var CARET = '<svg class="cedar-dd__caret" width="12" height="8" viewBox="0 0 12 8" aria-hidden="true"><path d="M1 1.5l5 5 5-5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"></path></svg>';

  function logoFor(name) {
    var n = (name || '').toLowerCase();
    for (var k in LOGOS) { if (n.indexOf(k) > -1) return LOGOS[k]; }
    return '';
  }

  function closeAll(except) {
    var open = document.querySelectorAll('.cedar-dd[data-cdd].is-open');
    for (var i = 0; i < open.length; i++) { if (open[i] !== except && open[i].__close) open[i].__close(); }
  }

  function build(sel) {
    if (sel.__cdd) return;
    sel.__cdd = true;
    var keepEmpty = sel.hasAttribute('data-dd-keep-empty');
    var placeholder = sel.getAttribute('data-placeholder') || '';
    var forceUp = sel.hasAttribute('data-dd-up');
    var wrap = document.createElement('div');
    wrap.className = 'cedar-dd' + (sel.getAttribute('data-dd-class') ? ' ' + sel.getAttribute('data-dd-class') : '');
    wrap.setAttribute('data-cdd', '');
    sel.parentNode.insertBefore(wrap, sel);
    wrap.appendChild(sel);
    sel.classList.add('cedar-dd__native');
    sel.tabIndex = -1;
    sel.setAttribute('aria-hidden', 'true');

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'cedar-dd__btn';
    btn.setAttribute('aria-haspopup', 'listbox');
    btn.setAttribute('aria-expanded', 'false');
    btn.innerHTML = '<img class="cedar-dd__logo" alt="" hidden><span class="cedar-dd__value"></span>' + CARET;
    var list = document.createElement('ul');
    list.className = 'cedar-dd__list';
    list.setAttribute('role', 'listbox');
    list.hidden = true;
    if (sel.getAttribute('aria-label')) list.setAttribute('aria-label', sel.getAttribute('aria-label'));
    wrap.appendChild(btn);
    wrap.appendChild(list);

    var valueEl = btn.querySelector('.cedar-dd__value');
    var logoEl = btn.querySelector('.cedar-dd__logo');
    var opts = [];

    for (var i = 0; i < sel.options.length; i++) {
      var o = sel.options[i];
      if (o.value === '' && !keepEmpty) continue;
      var li = document.createElement('li');
      li.className = 'cedar-dd__opt';
      li.setAttribute('role', 'option');
      li.tabIndex = -1;
      li.setAttribute('data-value', o.value);
      var lg = logoFor(o.text);
      if (lg) {
        var im = document.createElement('img');
        im.className = 'cedar-dd__logo';
        im.alt = '';
        im.src = lg;
        li.appendChild(im);
      }
      var sp = document.createElement('span');
      sp.textContent = o.text;
      li.appendChild(sp);
      list.appendChild(li);
      opts.push(li);
    }

    function sync() {
      var cur = sel.options[sel.selectedIndex];
      var txt = cur ? cur.text : '';
      var isPh = !cur || (cur.value === '' && !keepEmpty);
      valueEl.textContent = isPh ? (placeholder || txt) : txt;
      var lg = isPh ? '' : logoFor(txt);
      if (lg) { logoEl.src = lg; logoEl.hidden = false; } else { logoEl.hidden = true; logoEl.removeAttribute('src'); }
      opts.forEach(function (li) {
        li.setAttribute('aria-selected', (!isPh && li.getAttribute('data-value') === sel.value) ? 'true' : 'false');
      });
    }

    function close() {
      list.hidden = true;
      wrap.classList.remove('is-open');
      btn.setAttribute('aria-expanded', 'false');
    }

    function open() {
      closeAll(wrap);
      list.hidden = false;
      wrap.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
      var r = btn.getBoundingClientRect();
      var below = window.innerHeight - r.bottom - 16;
      var above = r.top - 16;
      var up = forceUp || (below < 240 && above > below);
      wrap.classList.toggle('cedar-dd--up', up);
      list.style.maxHeight = Math.max(150, Math.min(340, up ? above : below)) + 'px';
      var s = list.querySelector('[aria-selected="true"]') || opts[0];
      if (s) { s.focus({ preventScroll: true }); list.scrollTop = Math.max(0, s.offsetTop - 60); }
    }

    function choose(li) {
      var v = li.getAttribute('data-value');
      close();
      btn.focus({ preventScroll: true });
      if (sel.value !== v) {
        sel.value = v;
        sel.dispatchEvent(new Event('change', { bubbles: true }));
      }
      sync();
    }

    btn.addEventListener('click', function () { if (wrap.classList.contains('is-open')) close(); else open(); });
    btn.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); open(); }
    });
    list.addEventListener('click', function (e) {
      var li = e.target.closest('.cedar-dd__opt');
      if (li) choose(li);
    });
    list.addEventListener('keydown', function (e) {
      var i = opts.indexOf(document.activeElement);
      if (e.key === 'ArrowDown') { e.preventDefault(); (opts[i + 1] || opts[0]).focus(); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); (opts[i - 1] || opts[opts.length - 1]).focus(); }
      else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); if (i > -1) choose(opts[i]); }
      else if (e.key === 'Escape') { e.preventDefault(); close(); btn.focus({ preventScroll: true }); }
      else if (e.key === 'Tab') { close(); }
    });
    sel.addEventListener('change', sync);
    wrap.__close = close;
    sel.__sync = sync;
    sync();
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest || !e.target.closest('.cedar-dd')) closeAll();
  });

  function place() {
    var bar = document.querySelector('.facets-container');
    if (!bar) return;
    var prog = document.querySelector('[data-cedar-prog]');
    var search = document.querySelector('[data-cedar-csearch]');
    if (prog && prog.parentNode !== bar) { bar.insertBefore(prog, bar.firstChild); prog.classList.add('is-moved'); }
    if (search && search.parentNode !== bar) {
      bar.insertBefore(search, prog && prog.parentNode === bar ? prog.nextSibling : bar.firstChild);
    }
  }

  function scan() {
    var sels = document.querySelectorAll('select[data-cedar-enhance]');
    for (var i = 0; i < sels.length; i++) build(sels[i]);
    place();
  }

  var timer;
  new MutationObserver(function () { clearTimeout(timer); timer = setTimeout(scan, 40); }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
})();
